import React from 'react';
import ExportSelect from 'pages/Balance/sections/ExportSelect';
import SvgSettings from '@bexs/dollar-icons/Settings';
import { useSelector } from 'store';
import { CustomButton } from 'styles/global';

function TableActions({ onFilterClick }: { onFilterClick: () => void }) {
  const { periodStart, document } = useSelector().filter;

  const filterSize = Object.values({ periodStart, document }).filter((item) =>
    Boolean(item)
  ).length;

  return (
    <>
      <ExportSelect />
      <CustomButton
        variation="primary-outline"
        size="small"
        onClick={onFilterClick}
        icon={<SvgSettings style={{ marginRight: '4px' }} />}
      >
        Filters | {filterSize}
      </CustomButton>
    </>
  );
}

export default TableActions;
